import { render, staticRenderFns } from "./PageDocCommandesAide.vue?vue&type=template&id=b592e36e&"
import script from "./PageDocCommandesAide.vue?vue&type=script&lang=js&"
export * from "./PageDocCommandesAide.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b592e36e')) {
      api.createRecord('b592e36e', component.options)
    } else {
      api.reload('b592e36e', component.options)
    }
    module.hot.accept("./PageDocCommandesAide.vue?vue&type=template&id=b592e36e&", function () {
      api.rerender('b592e36e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Commandes/PageDocCommandesAide.vue"
export default component.exports